import type { KgInsightThemeType } from '@api';
import { Chip } from '@design/components/chip/Chip';
import { ThemeSearchLogo } from '@terminal/components/theme-search-logo/ThemeSearchLogo';
import { useTheme } from '@terminal/react-query-hooks/themes/useThemeOverview';
import clsx from 'clsx';
import { MouseEvent } from 'react';
import styles from './FollowThemePill.module.scss';

export interface FollowThemePillProps {
  themeId: string;
  themeName: string;
  logoUrl?: string;
  themeType?: KgInsightThemeType;
  isClickable?: boolean;
  onRemove: (e: MouseEvent) => void;
  onClick?: (e: MouseEvent) => void;
}

export const FollowThemePill = ({
  themeId,
  themeName,
  logoUrl,
  themeType,
  onRemove,
  onClick,
  isClickable = true,
}: FollowThemePillProps) => {
  const { data: theme } = useTheme({ themeId: !!logoUrl ? '' : themeId });
  const resolvedLogoUrl = !!logoUrl ? logoUrl : theme?.logo_url;

  const handleRemove = (e: MouseEvent) => {
    e.stopPropagation();
    onRemove(e);
  };

  return (
    <Chip
      className={clsx(styles.pill, { [styles.noClickable]: !isClickable })}
      type={'filter'}
      label={themeName}
      assetLogo={
        <ThemeSearchLogo
          name={themeName}
          logoUrl={resolvedLogoUrl}
          themeType={themeType}
          size={16}
        />
      }
      onRightIconClick={handleRemove}
      onClick={onClick}
      data-testid={`follow-themes-pill-${themeId}`}
    />
  );
};
